/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m8 0c4.4116863 0 8 3.58853125 8 7.99951506 0 4.41195374-3.5883137 8.00048494-8 8.00048494-4.41168627 0-8-3.5885312-8-8.00048494 0-4.41098381 3.58831373-7.99951506 8-7.99951506zm0 14.54519c3.6086798 0 6.5452782-2.9358065 6.5452782-6.54567494 0-3.60889858-2.9365984-6.54470509-6.5452782-6.54470509-3.60964965 0-6.54527822 2.93580651-6.54527822 6.54470509 0 3.60986844 2.93562857 6.54567494 6.54527822 6.54567494zm2.689443-9.29345485c.2751885-.30958707.7492428-.33747262 1.0588299-.06228411.3095871.27518852.3374726.7492428.0622841 1.05882987l-4.00000001 4.49999999c-.28669249.3225291-.78574975.3371945-1.09088708.0320572l-2.5-2.49999998c-.29289321-.29289322-.29289321-.76776695 0-1.06066017.29289322-.29289322.76776696-.29289322 1.06066018 0l1.93755729 1.93755729z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;